import api from './api';
import { ApiResponse, unwrapApiResponse } from '@/utils/api-response.util';

export type TelegramStatus = 'NOT_CONNECTED' | 'pending' | 'active' | 'blocked';

export interface TelegramStatusResponse {
  status: TelegramStatus;
}

export interface TelegramLinkResponse {
  link: string;
}

export const getTelegramStatus = async (): Promise<TelegramStatusResponse> => {
  const response = await api.get<ApiResponse<TelegramStatusResponse>>('/expert/telegram/status');
  return unwrapApiResponse<TelegramStatusResponse>(response);
};

export const getTelegramLink = async (): Promise<TelegramLinkResponse> => {
  const response = await api.post<ApiResponse<TelegramLinkResponse>>('/expert/telegram/link');
  return unwrapApiResponse<TelegramLinkResponse>(response);
};

export const disconnectTelegram = async (): Promise<void> => {
  const response = await api.delete<ApiResponse<void>>('/expert/telegram/disconnect');
  return unwrapApiResponse<void>(response);
};
